import uuidv4 from 'uuid/v4';
import moment from 'moment';
import 'moment/locale/en-gb';

export default class IdempotencyKeyService {
    static getIdempotencyKey(){
        const dateStamp = moment(new Date()).format("D-M-YY-H-m-s");
        return `${dateStamp}-${uuidv4()}`;
    }
}